import React from "react";

import SectionContainer from "../components/common/SectionContainer";
import SectionTitle from "../components/common/SectionTitle";

import CaseStudyHero from "../components/caseStudies/CaseStudyHero";
import CaseStudyGrid from "../components/caseStudies/CaseStudyGrid";

import CTASection from "../components/sections/CTASection";
import Seo from "../seo/Seo";
import pageMeta from "../data/pageMeta";

function CaseStudiesPage() {
    return (
        <>
            <Seo
                title={pageMeta.caseStudies.title}
                description={pageMeta.caseStudies.description}
            />
            <CaseStudyHero />

            <SectionContainer background="#ffffff">
                <SectionTitle
                    title="Featured Growth Projects"
                    subtitle="Examples of business challenges, strategic solutions and measurable outcomes."
                />

                <CaseStudyGrid />
            </SectionContainer>

            <CTASection />
        </>
    );
}

export default CaseStudiesPage;